import React, { useEffect, useRef, useState } from 'react';
import { Button, ButtonGroup, Form } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faClock, faSearch } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment-timezone';
import flatpickr from 'flatpickr';
import { MandarinTraditional } from 'flatpickr/dist/l10n/zh-tw';
import 'flatpickr/dist/flatpickr.min.css';

export default function MeasurementNavigation({ history, loading, historical, onSelect, projectId }) {
    const [time, setTime] = useState('');
    const timeInput = useRef(null);
    const picker = useRef(null);
    useEffect(() => {
        picker.current = flatpickr(timeInput.current, {
            locale: MandarinTraditional,
            dateFormat: 'Y-m-d H:i:S',
            enableTime: true, enableSeconds: true, time_24hr: true,
            allowInput: true, disableMobile: true,
            onChange: ([date]) => setTime(date ? flatpickr.formatDate(date, 'Y-m-d\\TH:i:S') : '')
        });
        return () => { picker.current.destroy(); picker.current = null; };
    }, []);
    useEffect(() => { picker.current?.setDate(time || null, false, 'Y-m-d\\TH:i:S'); }, [time]);
    useEffect(() => { if (loading) picker.current?.close(); }, [loading]);
    useEffect(() => { setTime(''); }, [projectId]);
    useEffect(() => {
        if (history?.selected?.date) setTime(moment(history.selected.date).format('YYYY-MM-DDTHH:mm:ss'));
    }, [history?.selected?.date]);
    const selectCursor = cursor => onSelect(history.isManual ? { at: cursor.date } : { meaNo: cursor.meaNo });
    return (
        <div className="mb-3" aria-label="量測紀錄選取">
            <div className="d-flex flex-wrap align-items-end gap-2">
                <ButtonGroup aria-label="切換量測紀錄">
                    <Button variant="outline-primary" size="sm" disabled={loading || !history?.previous}
                        onClick={() => selectCursor(history.previous)}>
                        <FontAwesomeIcon icon={faChevronLeft} className="me-1" />上一筆
                    </Button>
                    <Button variant="outline-primary" size="sm" disabled={loading || !history?.next}
                        onClick={() => selectCursor(history.next)}>
                        下一筆<FontAwesomeIcon icon={faChevronRight} className="ms-1" />
                    </Button>
                    <Button variant="outline-primary" size="sm" disabled={loading || !historical}
                        onClick={() => onSelect({})}>
                        <FontAwesomeIcon icon={faClock} className="me-1" />回到最新
                    </Button>
                </ButtonGroup>
                <Form className="d-flex flex-wrap align-items-end gap-2" onSubmit={event => {
                    event.preventDefault();
                    // Flatpickr debounces time-field onChange; read its current date
                    // so clicking immediately after changing seconds uses that time.
                    const date = picker.current?.selectedDates[0];
                    if (date && !loading) onSelect({ at: flatpickr.formatDate(date, 'Y-m-d\\TH:i:S') });
                }}>
                    <Form.Group controlId="overview-measurement-time" style={{ minWidth: 0 }}>
                        <Form.Label className="small mb-1">指定時間</Form.Label>
                        <Form.Control ref={timeInput} type="text" size="sm" required autoComplete="off"
                            placeholder="YYYY-MM-DD HH:mm:ss" disabled={loading} />
                    </Form.Group>
                    <Button type="submit" variant="outline-primary" size="sm" disabled={loading || !time}>
                        <FontAwesomeIcon icon={faSearch} className="me-1" />查看
                    </Button>
                </Form>
            </div>
        </div>
    );
}
